import React from 'react'
import MaskedInput from 'react-text-mask'

function InputPhoneMobileFull({ value, onChange, disabled = false }) {
    const mask = ['+', '5', '5', ' ', '(', /\d/, /\d/, ')', ' ', /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', '-', ' ', /\d/, /\d/, /\d/, /\d/];

    return (
        <MaskedInput 
            inputMode='numeric' 
            mask={mask} 
            placeholder='(99) 9 9999 - 9999' 
            className="form-control" 
            value={value} 
            onChange={value => {
                onChange(value.target.value)
            }} 
            disabled={disabled}
        ></MaskedInput>
    )
}

export default InputPhoneMobileFull